export function useWhatsApp() {
  const openWhatsApp = (phone: string, message: string) => {
    const encodedMessage = encodeURIComponent(message)
    const whatsappLink = `https://wa.me/${phone}?text=${encodedMessage}`
    window.open(whatsappLink, '_blank')
  }
  return { openWhatsApp }
}
